import 'document-register-element/build/document-register-element';
import Vue from 'vue';
import Appraiser from '@/components/Appraiser.vue';
import vueCustomElement from 'vue-custom-element';
import 'core-js/modules/es7.object.values';
import 'core-js/modules/es7.object.entries';
import 'core-js/modules/es7.array.includes';
import 'core-js/modules/es6.promise.js';
import 'custom-event-polyfill';
import * as VueGoogleMaps from 'vue2-google-maps';
import { MediaQueries } from 'vue-media-queries';
import VueGtm from 'vue-gtm';

const mediaQueries = new MediaQueries();
Vue.use(mediaQueries);
Vue.config.productionTip = false;
Vue.use(vueCustomElement);
Vue.use(VueGtm);

Vue.use(VueGoogleMaps, {
	load: {
		key: window.appraiserGoogleApiKey || 'AIzaSyAJXH0i55nyhIi6HMDVznqkfkazCljy2lQ'
	}
});
Vue.customElement('appraiser-element', Appraiser, {
	beforeCreateVueInstance(RootComponentDefinition) {
		RootComponentDefinition.mediaQueries = mediaQueries;
		return RootComponentDefinition;
	},
	destroyTimeout: 100
});
